<template>
  <div>
    <h3 class="mb-5">Departments & Teams</h3>
    <div class="h4 mb-5">
      編輯Department 於Career Page的封面圖文及Department Introduction Page內頁
    </div>
    <!-- Items -->
    <div>
      <div
        class="form-item d-flex py-3 align-center"
        v-for="(item, i) in career.teams"
        :key="i"
      >
        <div
          class="w-40px h-40px bg-cover bg-center"
          :style="{
            'background-image': `url(${item.visual})`,
          }"
        ></div>
        <div class="h4 ml-5">{{ item.title }}</div>
        <div class="ml-auto">
          <button class="btn square ml-10px" @click="editItem(item)">
            <v-icon>edit</v-icon>
          </button>
          <button class="btn square ml-10px" @click="deleteItem(item)">
            <v-icon>delete</v-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    career: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions('career', {
      getCareer: 'find',
      clear: 'clear',
      initTeamDetail: 'initTeamDetail',
      deleteTeam: 'deleteTeam',
    }),
    editItem(detail) {
      this.clear();
      this.initTeamDetail(detail);
      this.$router.push({
        name: 'DepartmentDetailEdit',
      });
    },
    async deleteItem(item) {
      await this.deleteTeam(item.id).then(() => {
        this.getCareer();
      });
    },
  },
};
</script>

<style></style>
